///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>

///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-base.ts"/>

module Meevo.Components.Controls.SmartMover {


    import Dictionary = _.Dictionary;

    export class LiabilitiesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected liabilities: SmartMoverCollectionBase<any>;

        public allSelectedLabel: string;
        public totalSelectedMessage: string;
        public title: string;

        get collection() {
            return this.liabilities;
        }

        constructor(model: Dictionary<any>, properties: string[], {criteria}, items: IListElement[] = []) {
            super(model, properties, criteria);

            this.liabilities = new SmartMoverCollectionBase(this.model[properties[0]], items, {criteria});
            this.title = 'LABEL_LIABILITIES';
            this.allSelectedLabel = 'LABEL_ALL_LIABILITIES';
            this.totalSelectedMessage = 'LABEL_TOTAL_LIABILITIES_SELECTED';
        }
    }
}